import React from 'react';
import PropTypes from 'prop-types';
import HelpNode from './HelpNode';
import RootHelpNode from './RootHelpNode';

class HelpNodeBrowser extends React.Component {
  static propTypes = {
    nodeHierarchy: PropTypes.array.isRequired,
    onExpand: PropTypes.func,
    selectedNodeId: PropTypes.string,
  };

  renderHelpNodeHierarchy() {
    const { nodeHierarchy } = this.props;
    return nodeHierarchy.map(rootNode => (
      <div
        key={rootNode.nodeId}
        className="aa-help-node-root"
      >
        { this.renderRootHelpNode(rootNode) }
      </div>
    ));
  }

  renderRootHelpNode(node) {
    const { onExpand } = this.props;
    return (
      <RootHelpNode
        title={node.title}
        onExpand={onExpand}
        key={node.nodeId}
      >
        { node.children.map(child => this.renderHelpNode(child)) }
      </RootHelpNode>
    );
  }

  renderHelpNode(node) {
    const { selectedNodeId } = this.props;
    return (
      <HelpNode
        title={node.title}
        nodeId={node.nodeId}
        isSelected={node.nodeId === selectedNodeId}
        key={node.nodeId}
      />
    );
  }

  render() {
    return (
      <div>{ this.renderHelpNodeHierarchy() }</div>
    );
  }
}

export default HelpNodeBrowser;
